// third-party
import { createSlice } from '@reduxjs/toolkit';

// project-imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// types
import { chat } from './chat';
import { AuditLogFilter, AuditLogStateProps } from 'types/auditLog';

export const urlLogs = process.env.REACT_APP_API_URL + '/api/audit/v1/logs';

const initialState: AuditLogStateProps = {
  logs: [],
  total: 0,
  page: 1,
  pageSize: 20
};

export const auditLog = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {
    setLogs(state, action) {
      state.logs = action.payload.data;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
    }
  }
});

export function getAuditLogs(filter: AuditLogFilter) {
  return async () => {
    try {
      const response = await axios.get(urlLogs, { params: filter });
      dispatch(auditLog.actions.setLogs(response.data));
    } catch (error) {
      dispatch(chat.actions.hasError(error));
    }
  };
}

// baixa como blob (não dá pra abrir a URL direto numa nova aba — precisa do Authorization
// que só o axios já tem configurado) e simula o clique num link temporário pra disparar o save
export function exportAuditLogs(filter: AuditLogFilter) {
  return async () => {
    try {
      const response = await axios.get(`${urlLogs}/export`, { params: filter, responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'auditoria.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      dispatch(chat.actions.hasError(error));
      throw error;
    }
  };
}

export default auditLog.reducer;
